import React, { Fragment, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    useGetUserById,
} from "../../../custom-hooks/use-users";
import {
    Breadcrumbs,
    Button,
    Spinner
} from "@material-tailwind/react";
import {
    convertToPresentableText,
} from "../../../utils/functions";
import {
    Building2Icon,
    HomeIcon,
    UserIcon,
} from "lucide-react";
import { BottomUXSpace } from "../../../components";
import BasicInfo from "./basicInfo";
import MeetingQuota from "./meetingQuota";
import DayPasses from "./daypasses";
import Contracts from "./contracts";
import AccountManagement from "./accountManagement";
import TeamMembers from "./teamMembers";
import { URLS } from "../../../router-x/routes";


// Functional component
const CustomerDetailsPage = () => {
    const { customerId } = useParams();
    const navigate = useNavigate();
    const {
        data: customerDetails,
        isLoading: isCustomerDetailsLoading,
        error: customerDetailsError,
        // refetch: refetchCustomerDetails,
    } = useGetUserById(customerId);

    const customer = useMemo(() => customerDetails?.data?.user || {}, [customerDetails?.data?.user]);

    // useEffect(() => {
    //     if (customer?.meetingRoomQuota) {
    //         setMeetingRoomQuota({
    //             monthlyHours: (customer?.meetingRoomQuota?.monthlyHours) / 60 || 0,
    //             meetingRoomHoursPerDay: (customer?.meetingRoomQuota?.meetingRoomHoursPerDay) / 60 || 0,
    //         });
    //     }
    // }, [customer]);

    if (isCustomerDetailsLoading) {
        return (
            <div className={`flex justify-center p-4 m-4 items-center h-screen border rounded-xl`}>
                <Spinner />
            </div>
        );
    }

    if (customerDetailsError) {
        return (
            <Fragment>
                <div className="p-4 flex flex-col justify-center items-center h-96">
                    <div className="p-4 text-red-600 text-center">
                        <h2 className="text-xl font-bold">Error Loading Customer</h2>
                        <p>{customerDetailsError.message || "Failed to load customer details"}</p>
                        <div>
                            <span className="text-gray-500 text-xs">Customer Id: {customerId}</span>
                        </div>
                        <Button className="rounded-full mt-4" variant="gradient" color="gray">
                            <span className="text-sm" onClick={() => navigate(URLS.ADMIN.CUSTOMER)}>
                                Go Back
                            </span>
                        </Button>
                    </div>
                </div>
            </Fragment>
        );
    }

    return (
        <div className="p-4 space-y-6">
            <div className="border rounded-xl p-6">
                <div className="">
                    <Breadcrumbs className="mb-4">
                        <Link to={URLS.ADMIN.ROOT} className="opacity-60 flex items-center gap-1">
                            <HomeIcon size={14} />
                            <span>Home</span>
                        </Link>
                        <Link to={URLS.ADMIN.CUSTOMER} className="opacity-60 flex items-center gap-1">
                            <Building2Icon size={14} />
                            <span>Customers</span>
                        </Link>
                        <span className="flex items-center gap-1">
                            {isCustomerDetailsLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <>
                                    <UserIcon size={14} />
                                    <span>{convertToPresentableText(customer?.name) || 'Customer Details'}</span>
                                </>
                            )}
                        </span>
                    </Breadcrumbs>
                </div>
                <div className="flex items-start justify-between">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">{convertToPresentableText(customer.name) || "Customer Name"}</h1>
                        <p className="text-sm text-gray-500 mt-1">{customer.jobTitle || "Job Title Not Set"}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${customer.isActive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
                            {customer.isActive ? "Active" : "Inactive"}
                        </span>
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            Customer - {convertToPresentableText(customer.role)}
                        </span>
                    </div>
                </div>
                <BasicInfo customer={customer} />
                <MeetingQuota customer={customer} />
            </div>
            <DayPasses customer={customer} />
            <Contracts customer={customer} />
            <AccountManagement customer={customer} />
            <TeamMembers customer={customer} />
            <BottomUXSpace />
        </div>
    );
};


export default CustomerDetailsPage;